import { render } from "./Group_confirmation.vue?vue&type=template&id=bc558188&scoped=true"
import script from "./Group_confirmation.vue?vue&type=script&lang=js"
export * from "./Group_confirmation.vue?vue&type=script&lang=js"

import "./Group_confirmation.vue?vue&type=style&index=0&id=bc558188&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc558188"]])

export default __exports__